import { styled } from 'styled-components';

import { breakpointLargeTablet, breakpointTablet } from 'src/styles/breakpoints';
import { colorNeutral } from 'src/styles/colors';
import { spacing2 } from 'src/styles/spacing';

export const StyledLinkContainer = styled.div`
  &:not(:last-child) {
    padding-bottom: ${spacing2};
  }

  @media (min-width: ${breakpointTablet}) {
    text-align: right;
  }

  @media (min-width: ${breakpointLargeTablet}) {
    &:not(:last-child) {
      padding-bottom: 0;
    }

    &:not(:last-child)::after {
      color: ${colorNeutral};
      content: '/';
      padding: 0 ${spacing2};
    }
  }
`;
